module.exports = __webpack_public_path__ + "static/media/paper-plane.99c6d51b.gif";